<div class="header-content" [ngClass]="{ 'content-column': !contentRow }">
  <ng-container *ngIf="!loading; else loadingTemplate">
    <div class="header-title" @fade>
      <h1 *ngIf="header" class="title-main">{{ header | translate }}</h1>
      <div *ngIf="headerTemplate" class="title-main">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      </div>
      <p *ngIf="info" class="title-info">{{ info | translate }}</p>
      <div *ngIf="headerActions" class="title-actions">
        <ng-container *ngTemplateOutlet="headerActions"></ng-container>
      </div>
    </div>
    <div *ngIf="contentActions" class="content-actions" @fade>
      <ng-container *ngTemplateOutlet="contentActions"></ng-container>
    </div>
  </ng-container>
</div>
<div *ngIf="navActions" class="nav-actions" @fade>
  <ng-container *ngTemplateOutlet="navActions"></ng-container>
</div>
<p-progressBar value="100" [showValue]="false" [mode]="indicator.mode$ | async"></p-progressBar>
<ng-template #loadingTemplate>
  <fa-icon icon="spinner-third" [spin]="true" size="2x" class="loading-indicator"></fa-icon>
</ng-template>
